module.exports = __webpack_public_path__ + "img/Fulfillment.1acf30f4.svg";